/**
 * The funds a POSTING picker offers: awarded funds (`is_active`, generated as
 * `status = 'awarded'`), plus the one already saved on the record
 * (`currentValue`) so an edit never drops a saved pipeline/closed fund off
 * the trigger. Order is preserved.
 *
 * Every posting form's fund picker goes through this one rule (`FundSelect`
 * and the hand-rolled selects of the AR/AP invoice, expense, AR/AP payment
 * and channel-sale forms). Planning and reporting surfaces —
 * `CreateBudgetDialog`, `IncomeStatementFilters` — list every fund instead:
 * a budget may plan a pipeline fund.
 *
 * Lives outside `hooks/useFunds.ts` (which re-exports it) so the many form
 * tests that factory-mock that hook module keep a real picker rule.
 */
export const pickableFunds = <T extends { id: string; is_active: boolean | null }>(
  funds: readonly T[] | null | undefined,
  currentValue?: string | null,
): T[] =>
  (funds ?? []).filter((fund) => fund.is_active === true || (!!currentValue && fund.id === currentValue));
